module.exports = __webpack_public_path__ + "media/images/icons/edit-d8fc95f5abd02ee34166fc7c4cb0af3b.svg";